import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "t6_title_h1" }

import { useRoute,useRouter } from 'vue-router';
    import { reactive,ref } from 'vue';
    import Step1 from './step1/index.vue';
    import Step2 from './step2/index.vue';
    import Step3 from './step3/index.vue';
    import Step4 from './step4/index.vue';
    import Step5 from './step5/index.vue';
    import NextStepButton from './nextStepButton.vue';
    import formData from '@/config/form';
    import { useStore } from "vuex";
    import { queryOneThingData, createProjid,getFormIdByGuideId, queryItemByServiceCode, preServiceMaterialList,cInsProjectBusinessRelationshipAdd } from "@/config/request";
    import { AREA_ID } from "@/config/const";
    import { ElMessage } from "element-plus";

    interface checkResultType{
        data: object,   //  当前步骤修改过的 publicData
        status: number  //  验证当前步骤是否符合进入下一步状态 200通过  500不通过
    }
    /**
     * 根据保存当前步骤信息
     */
    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

    const route = useRoute()
    const store = useStore()
    const router = useRouter()

    const userInfo = store.state.userInfomation
    console.log('userInfo::',userInfo)

    const step1 = ref()
    const step2 = ref()
    const step3 = ref()
    const step4 = ref()
    const step5 = ref()

    const getStepData = async(val:number) => {
        const stepList = [step1,step2,step3,step4,step5]
        const current = (stepList[data.step-1]).value
        if(data.step < 5){
            let checkResult:checkResultType = await current.check()
            console.log('checkResult',checkResult);

            data.declarationMessage = checkResult.data
            if(checkResult.status === 200){
                console.log('最终data.declarationMessage：',data.declarationMessage)
                formateStep(val)    //  进入下一步
            }
            // 暂时全部可以下一步
            //formateStep(val)
        }else if(data.step === 5){
            router.push('/user-center')
        }

    }

    const data = reactive({
        query:{} as any,
        step:1,
        declarationMessage: JSON.parse(JSON.stringify(formData)),    //  申报过程中的信息，几个申报页面共享
        noform: '0',        // 用来判断是否有表单 0有  1没有
        itemList:[],
        matterList:[] as any,
        materials: [] as any,
    })

    const formateStep = (val:number) => {
        if(val < 1){
            val = 1
        }else if(val > 5){
            val = 5
        }
        data.step = val
        document.querySelector('#no_banner')!.scrollIntoView()
    }
    const nextStep = (val:number) => {
        let nextVal = ++val
        if(val === 2 && data.noform === '1'){
            nextVal++
        }
        getStepData(nextVal)       //  验证保存数据
    }
    const prevStep = (val:number) => {
        let prevVal = --val
        if(val === 2 && data.noform === '1'){
            prevVal--
        }
        formateStep(prevVal)
    }

    const getQueryData = async() => {
        data.query = route.query
        let routeQuery = route.query as any
        data.declarationMessage.selectServiceCode = routeQuery.selectServiceCode
        data.declarationMessage.basicInfo.preApasinfo.applyCardnumber = userInfo.certNo
        data.declarationMessage.basicInfo.preApasinfo.receiveUseid = userInfo.proviceId
        if(userInfo.usertype == '1'){   // 个人
            data.declarationMessage.basicInfo.preApasinfo.applyname = decodeURI(userInfo.userName) // 个人姓名
            data.declarationMessage.basicInfo.preApasinfo.contactman = decodeURI(userInfo.userName) // 默认填写
        }else{  // 法人
            data.declarationMessage.basicInfo.preApasinfo.applyname = decodeURI(userInfo.incname)  // 企业名称
            data.declarationMessage.basicInfo.preApasinfo.legalman = decodeURI(userInfo.userName)  // 法人姓名
            data.declarationMessage.basicInfo.preApasinfo.contactman = decodeURI(userInfo.userName) // 默认填写
        }

        data.declarationMessage.basicInfo.preApasinfo.servicecode = routeQuery.selectServiceCode
        data.declarationMessage.basicInfo.preApasinfoRelation.servicecode = routeQuery.selectServiceCode
        data.declarationMessage.oneThing.modelCode = routeQuery.modelCode
        data.declarationMessage.oneThing.modelName = routeQuery.modelName
        data.declarationMessage.oneThing.areaCode = routeQuery.areaCode
        data.declarationMessage.oneThing.handlingConditions = routeQuery.handlingConditions
        data.declarationMessage.basicInfo.preApasinfo.corpName = userInfo.corpName
        data.declarationMessage.basicInfo.preApasinfo.applyname = userInfo.userName
        data.declarationMessage.basicInfo.preApasinfo.contactman = userInfo.userName
        // 暂时注释 让用户自己填手机号
        data.declarationMessage.basicInfo.preApasinfo.telphone = userInfo.userMobile
        data.declarationMessage.basicInfo.preApasinfo.contactmanCardnumber = userInfo.certNo
        data.declarationMessage.basicInfo.preApasinfo.contactmanCardnumber2 = userInfo.certNo
        data.declarationMessage.basicInfo.other.guideId = routeQuery.guideId

        let params = {
            modelCode: data.declarationMessage.oneThing.modelCode
        }
        getOneThingData(params)

        let type = '1'
        if ('2' == userInfo.usertype) {
            type = '2'
        }
        changeType(type)
        getMaterialList()
    }
    const getOneThingData = async(params:any) => {
        let ontThingData = await queryOneThingData(params) as any
        if(ontThingData.code == 200){
            let obj = ontThingData.result.records[0]
            data.declarationMessage.oneThing.hangyeType_dictText = obj.hangyeType_dictText
            data.declarationMessage.oneThing.areaCode = obj.areaCode

            data.declarationMessage.oneThing.unid = obj.unid
            data.declarationMessage.oneThing.modelClassName = obj.modelClassName
            data.declarationMessage.modelCode = obj.modelCode
            data.declarationMessage.answerInfo.modelId =obj.modelCode
            data.declarationMessage.answerInfo.areaCode =obj.areaCode
            data.declarationMessage.answerInfo.modelunid =obj.unid

            data.declarationMessage.basicInfo.preApasinfo.extend = 'I'
            data.declarationMessage.basicInfo.preApasinfo.dataversion = '1'
            data.declarationMessage.basicInfo.preApasinfo.syncStatus = '0'
            data.declarationMessage.basicInfo.preApasinfo.flowXml = '</OPINION><NAME>autooperid</NAME><TEL/><SPECIALS/><DE><DES>'

            let code = ''
            for(let i = 1; i <= 6; i++){
                const num = Math.floor(Math.random()*10)
                code += num
            }
            data.declarationMessage.basicInfo.preApasinfo.projpwd =code
            data.declarationMessage.basicInfo.preApasinfo.applyfrom='1'
            data.declarationMessage.basicInfo.preApasinfo.qlKind = obj.serviceType
            data.declarationMessage.basicInfo.preApasinfo.applyPropertiy = '99'
            data.declarationMessage.basicInfo.preApasinfo.busType = '0'
            data.declarationMessage.basicInfo.preApasinfo.deptname = obj.deptName

            data.declarationMessage.basicInfo.preApasinfo.infotype = obj.infoType
            data.declarationMessage.basicInfo.preApasinfo.servicename = obj.modelName
            data.declarationMessage.oneThing.modelName = obj.modelName
            data.declarationMessage.oneThing.hangyeType_dictText = obj.hangyeType_dictText
            data.declarationMessage.oneThing.handlingConditions = obj.handlingConditions
            data.declarationMessage.basicInfo.preApasinfoRelation.promiseDays = obj.promiseDays
            data.declarationMessage.basicInfo.preApasinfoRelation.legalDays = obj.legalDays
            data.declarationMessage.basicInfo.preApasinfoRelation.servicecode = obj.serviceCode
            data.declarationMessage.basicInfo.preApasinfoRelation.formUnid = obj.fomrId
            data.declarationMessage.basicInfo.preApasinfo.deptid = obj.deptCode
            data.declarationMessage.basicInfo.preApasinfo.ssOrgcode = obj.deptCode
            let name = data.declarationMessage.basicInfo.preApasinfo.servicename
            data.declarationMessage.basicInfo.preApasinfo.projectname = name+' 的申请'
            data.declarationMessage.pname = data.declarationMessage.basicInfo.preApasinfo.projectname
            data.declarationMessage.protime = obj.promiseDays+' (工作日)'
            data.declarationMessage.basicInfo.preApasinfoExt.taskCode = obj.implementCode
            data.declarationMessage.basicInfo.preApasinfoExt.applyerTypeCode = '1'
            data.declarationMessage.basicInfo.preApasinfoExt.syncStatus = 'I'
            data.declarationMessage.basicInfo.preApasinfoExt.catalogCode = obj.catalogUnid

            // 创建一个业务id
            let deptCode = AREA_ID // 这参数值暂时写固定
            let params2 = {
                areaCode: data.declarationMessage.oneThing.areaCode,
                deptCode: deptCode
            }
            let result = await createProjid(params2) as any
            let projid = '100'
            if(result.code == 200){
                projid = result.result

              if (data.query.projectcode != null && data.query != ''){
                let params ={
                  projid: result.result,
                  projectId: data.query.projectcode
                }
                await cInsProjectBusinessRelationshipAdd(params) as any
              }

            }
            data.declarationMessage.basicInfo.preApasinfo.projid = projid
            data.declarationMessage.basicInfo.preApasinfoExt.projid = projid
            data.declarationMessage.basicInfo.preApasinfoRelation.projid = projid
            data.declarationMessage.basicInfo.preNode.projid = projid
            data.declarationMessage.formJson.projid = projid
            data.declarationMessage.answerInfo.onethingUnid = projid
            let params3 = {
                guideId: data.declarationMessage.basicInfo.other.guideId
            }

            let res = await getFormIdByGuideId(params3) as any
            if(res.code == 200){
                data.declarationMessage.formJson.formId = res.result.formId || ''
            }
            if(!data.declarationMessage.formJson.formId){
                //ElMessage.warning('未配置表单信息')
                data.noform = '1'
            }
        }
    }
    const changeType = (type:string) => {
        data.declarationMessage.basicInfo.preApasinfo.applyType = type == '1'?'自然人':'企业法人'
        console.log(data.declarationMessage.basicInfo.preApasinfo.applyCardtype)
        if(type == '1'){
            data.declarationMessage.basicInfo.preApasinfo.applyCardtype = '居民身份证'
            data.declarationMessage.basicInfo.preApasinfo.contactmanCardtype = '居民身份证'
        }else{
            data.declarationMessage.basicInfo.preApasinfo.applyCardtype = '统一社会信用代码证'
            data.declarationMessage.basicInfo.preApasinfo.contactmanCardtype = '居民身份证'
        }
    }
    const getMaterialList = async() => {
        let param = {
            serviceCode: data.declarationMessage.basicInfo.preApasinfo.servicecode
        }
        // 根据事项id查询事项信息
        let res = await queryItemByServiceCode(param) as any
        console.log('res::::',res);

        if (res.code === 200) {
            //data.itemList = res.result.records
        }
        let matterParams = {
            code: data.declarationMessage.basicInfo.preApasinfo.servicecode,
            modelCode: data.declarationMessage.oneThing.modelCode,
            //selectServiceCode: data.declarationMessage.basicInfo.preApasinfo.servicecode
        }
        console.log('参数：', matterParams);

        let matterResult = await preServiceMaterialList(matterParams) as any
        console.log('matterResult',matterResult);

        if (matterResult.code == 200) {
            data.matterList = matterResult.result;
            let queryMaterials = data.matterList;
            let saveMaterials = [];
            for (let a = 0; a < data.matterList.length; a++) {
                let m = {} as any
                m['copyNum'] = queryMaterials[a].copyNum || queryMaterials[a].endCopyNum
                m['importLevel'] = queryMaterials[a].isNecessary || queryMaterials[a].importLevel== 1?'Y':queryMaterials[a].importLevel== 2?'N':"无"
                m['memo'] = queryMaterials[a].endStandard || ''
                m['memo1'] = queryMaterials[a].endStandard1 || ''
                m['srcNum'] = queryMaterials[a].srcNum || queryMaterials[a].endSrcNum
                m['amount'] = ''
                m['attrid'] = queryMaterials[a].code
                m['attrname'] = queryMaterials[a].materialAlias || queryMaterials[a].name
                m['fileUrl'] = ''
                m['filename'] = ''
                m['istake'] = ''
                m['lastUpdateTime'] = ''
                m['attrCode'] = queryMaterials[a].attrCode
                m['onethingUnid'] = data.declarationMessage.basicInfo.preApasinfo.projid
                m['sortid'] = queryMaterials[a].sortid
                m['taketype'] = 'upload'
                m['unid'] = uuid()
                m['materialUploadType'] = queryMaterials[a].materialUploadType
                m['preOnethingAttrFileList'] = []
                m['isShow'] = queryMaterials[a].isShow
                m['preAttrFiles2'] = []
                saveMaterials.push(m)
            }
            data.materials = saveMaterials.filter((material:any) => material.isShow == 'Y')
            data.declarationMessage.basicInfo.preAttrs = data.materials;
            console.log('queryMaterials',queryMaterials);

            if (data.materials.length < 1) {
                console.log('无材料，直接下一步');

            }
        }
    }

    const uuid = () => {
        let s = [] as any
        let hexDigits = '0123456789abcdef'
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
        }
        s[14] = '4'
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
        s[8] = s[13] = s[18] = s[23] = '-'

        let uuid = s.join('')
        return uuid
    }
    const init = () => {
        getQueryData()
    }
    init()
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_breadCream" }, [
          _createElementVNode("span", null, "首页"),
          _createTextVNode(),
          _createElementVNode("i", null, ">"),
          _createTextVNode(),
          _createElementVNode("span", null, "网上办事"),
          _createTextVNode(),
          _createElementVNode("i", null, ">"),
          _createTextVNode(),
          _createElementVNode("span", null, "一件事申报")
        ], -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(data.declarationMessage.basicInfo.preApasinfo.servicename), 1),
        _createElementVNode("div", null, [
          (data.step === 1)
            ? (_openBlock(), _createBlock(Step1, {
                key: 0,
                ref_key: "step1",
                ref: step1,
                publicData: data.declarationMessage
              }, null, 8, ["publicData"]))
            : (data.step === 2)
              ? (_openBlock(), _createBlock(Step2, {
                  key: 1,
                  ref_key: "step2",
                  ref: step2,
                  publicData: data.declarationMessage
                }, null, 8, ["publicData"]))
              : (data.step === 3)
                ? (_openBlock(), _createBlock(Step3, {
                    key: 2,
                    ref_key: "step3",
                    ref: step3,
                    publicData: data.declarationMessage
                  }, null, 8, ["publicData"]))
                : (data.step === 4)
                  ? (_openBlock(), _createBlock(Step4, {
                      key: 3,
                      ref_key: "step4",
                      ref: step4,
                      publicData: data.declarationMessage
                    }, null, 8, ["publicData"]))
                  : (data.step === 5)
                    ? (_openBlock(), _createBlock(Step5, {
                        key: 4,
                        ref_key: "step5",
                        ref: step5,
                        publicData: data.declarationMessage
                      }, null, 8, ["publicData"]))
                    : _createCommentVNode("", true),
          _createVNode(NextStepButton, {
            publicData: data.declarationMessage,
            onNextStep: nextStep,
            onPrevStep: prevStep,
            step: data.step
          }, null, 8, ["publicData", "step"])
        ])
      ])
    ])
  ]))
}
}

})